import React, { useState } from 'react'

const withEntityDelete = WrappedComponent => {
  return props => {
    const [deleteModalComponent, setDeleteModalComponent] = useState(null)

    return (
      <WrappedComponent
        deleteModalComponent={deleteModalComponent}
        setDeleteModalComponent={setDeleteModalComponent}
        {...props}
      />
    )
  }
}

export default withEntityDelete
